<template>
  <div>

    <!-- Search -->
    <div class="row mt-4">
      <div class="col-md-8">
        <input class="input form-control" @keypress.enter="find()" v-model="query.generic"
          placeholder="Pesquisar por apelido, login ou serviço">
        <search-icon @click="find()" class="icon icon-within" />
      </div>

      <button class="col-md-1 ml-2 btn-sm btn-outline nowrap" :class="{ 'btn-outline-active': showFilter }"
        @click="showFilter = !showFilter">
        Filtros
        <chevron-down-icon class="fa-angle-right" :class="{ 'rotate-90': showFilter }" />
      </button>

      <button v-if="changeQuery" @click="find()" class="btn btn-link">
        Aplicar filtros ({{ numberOfBadges }})
      </button>
    </div>

    <!-- Badges -->
    <div class="row">
      <div class="col-md-12">
        <BadgeFilters :query="query" @clearBadge="find()" @clearAllBadges="find()"
          :amount-changed="updateNumberOfBadges"
          :filters="[filterStartDate, filterEndDate, filterPreferential, filterAccount, filterApp]" />
      </div>
    </div>

    <!-- Filters -->
    <template v-if="showFilter">
      <div class="row mt-4">
        <div class="col-md-4">
          <label for="credential-account">Conta</label>
          <Select2 :options="filterAccount" v-model="query.accountId" id="credential-account"
            title-load="Carregando contas..." />
        </div>

        <div class="col-md-4">
          <label for="credential-app">App</label>
          <Select2 :options="filterApp" v-model="query.appName" id="credential-app" />
        </div>

        <div class="col-md-4">
          <label for="credential-preferential">Preferencial</label>
          <select id="credential-preferential" v-model="query.preferential" class="form-control">
            <option value="">Todos</option>
            <option value="true">Sim</option>
            <option value="false">Não</option>
          </select>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-md-4">
          <label for="type-period">Tipo do período</label>
          <select v-model="query.periodType" id="type-period" class="form-control">
            <option value="created_at">Data de criação</option>
            <option value="updated_at">Data de atualização</option>
          </select>
        </div>

        <div class="col-md-4">
          <label for="start-date">Data inicial</label>
          <input v-model="query.startDate" type="date" id="start-date" class="form-control">
        </div>

        <div class="col-md-4">
          <label for="end-date">Data final</label>
          <input v-model="query.endDate" type="date" id="end-date" class="form-control">
        </div>
      </div>

    </template>
    <hr>

    <!-- Buttons -->
    <div class="row mt-2">
      <div class="col-md-12">
        <button class="btn btn-primary mt-1 mr-1" @click="exportReport" :disabled="disabledReport">
          Baixar relatório
        </button>
      </div>
    </div>

    <!-- Info -->
    <div class="row mt-4">
      <div class="col-md-12">
        <strong class="mr-3">
          {{ infoTotalModels }}
        </strong>

        <button class="btn btn-outline ml-3 mb-1" v-if="credentials.length > 0" @click="changeCheckAll"
          :class="{ 'btn-outline-active': checkAll }">
          {{ !checkAll ? 'Selecionar todas' : 'Desmarcar todas' }} ({{ meta.totalCount || 'Calculando' }})
        </button>

        <div class="float-right" style="display: inline-flex;align-items: center;">
          <small class="mr-2" style="white-space: nowrap">Ordenar por:</small>
          <select v-model="orderBy" class="browser-default custom-select">
            <option value="created_at">Data de criação</option>
            <option value="updated_at">Data de atualização</option>
            <option value="nickname">Apelido</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Table -->
    <div class="row flex-fill d-flex justify-content-start">
      <div class="col-sm-12 mt-2">
        <table class="table table-borderless table-dfe">
          <thead>
            <tr>
              <th>
                <BkpsCheckBox :value="checkAllRow" @input="changeCheckAllRow" />
              </th>
              <th>ID</th>
              <th>Apelido</th>
              <th>App</th>
              <th>Serviço</th>
              <th>Conta</th>
              <th>Preferencial</th>
              <th>Criado por</th>
              <th>Atualizado por</th>
              <th>Criado em</th>
              <th>Atualizado em</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="credential in credentials" :key="credential.id">
              <td>
                <BkpsCheckBox v-model="credential.checked" @input="changeCheckRow" />
              </td>
              <td>{{ credential.id }}</td>
              <td>{{ credential.nickname || '-' }}</td>
              <td>{{ credential.appName || '-' }}</td>
              <td>{{ credential.serviceName || '-' }}</td>
              <td>{{ getAccountName(credential) }}</td>
              <td>
                <span :class="credential.preferential ? 'badge-success' : 'badge-secondary'" class="badge">
                  {{ credential.preferential ? 'Sim' : 'Não' }}
                </span>
              </td>
              <td>{{ credential.createdBy || '-' }}</td>
              <td>{{ credential.updatedBy || '-' }}</td>
              <td>{{ credential.createdAt | datetime }}</td>
              <td>{{ credential.updatedAt | datetime }}</td>
              <td>
                <button @click="showCredential(credential)" class="btn btn-outline">Detalhes</button>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="row">
          <div class="col-md-12 my-1">
            <Pagination v-model="meta.currentPage" :total-count="meta.totalCount" :total-pages="meta.totalPages"
              @pagination="pagination" />
          </div>
        </div>
      </div>

      <ShowDataModal v-if="currentCredential" v-model="showModal" :header="currentCredential.nickname"
        :data="currentCredential" :deep="3" />
    </div>
  </div>

</template>

<script>
import BadgeFilters from '@/components/shares/BadgeFilters'
import BkpsCheckBox from '@/components/shares/specialTag/BkpsCheckBox'
import CheckedModels from '@/mixins/CheckedModels'
import GlobalLoading from '@/mixins/GlobalLoading'
import ModelMapper from '@/mixins/ModelMapper'
import Pagination from '@/components/shares/specialTag/Pagination'
import Select2 from '@/components/shares/Select2'
import ShowDataModal from '@/components/admin/ShowDataModal'
import { ChevronDownIcon, SearchIcon } from 'vue-feather-icons'
import { Filter } from '@/models/filter'

export default {
  components: { BadgeFilters, BkpsCheckBox, ChevronDownIcon, Pagination, SearchIcon, Select2, ShowDataModal },
  computed: {
    credentials() {
      return this.getModels || []
    },
    disabledReport() {
      return this.meta.totalCount === 0 || (!this.checkAll && !this.credentials.some(c => c.checked))
    }
  },
  created() {
    this.defaultModelSetting.updateQueryURL = true
    this.order.push('created_at', 'desc')
    this.$set(this.query, 'periodType', 'created_at')
    this.filterAccount = this.buildFilterAccount(this.allAccounts.data)

    this.asyncTemplateSelect({
      byURL: true,
      pagination: true
    })
  },
  data: () => ({
    currentCredential: null,
    filterAccount: null,
    filterApp: new Filter({
      key: 'appName',
      label: 'App',
      type: 'select',
      table: [
        { label: 'CM-Frotas', value: 'cm-frotas' },
        { label: 'CM-Taxas', value: 'cm-taxas' },
        { label: 'CM-Crono', value: 'cm-crono' },
        { label: 'CM-Embarcador', value: 'cm-embarcador' }
      ]
    }),
    filterEndDate: new Filter({
      key: 'endDate',
      label: 'Data final',
      type: 'date'
    }),
    filterStartDate: new Filter({
      key: 'startDate',
      label: 'Data inicial',
      type: 'date'
    }),
    filterPreferential: new Filter({
      key: 'preferential',
      label: 'Preferencial',
      type: 'select',
      table: [
        { label: 'Sim', value: 'true' },
        { label: 'Não', value: 'false' }
      ]
    }),
    modelPathPrefix: 'admin',
    nameModel: 'Credential',
    orderBy: 'created_at',
    showModal: false
  }),
  inject: ['allAccounts', 'buildFilterAccount', 'getAccountName'],
  methods: {
    changeCheckAll() {
      this.changeCheck({ checkAll: !this.checkAll, sources: this.credentials })
    },
    changeCheckAllRow(value) {
      this.changeCheck({ checkAllRow: value, sources: this.credentials })
    },
    changeCheckRow() {
      this.changeCheck({ sources: this.credentials })
    },
    exportReport() {
      let params
      let amount

      if (this.checkAll) {
        params = this.buildParams()
        amount = this.meta.totalCount
      } else {
        const ids = this.credentials.filter(c => c.checked).map(c => c.id)
        params = { q: { id: ids } }
        amount = ids.length
      }

      if (!confirm(`Exportar ${amount} Credencial(is).\nTem certeza?`))
        return

      this.openGlobalLoad()
      this.axios.get('admin/credentials/report', { params })
        .then(response => {
          if (response.data)
            this.$parse.downloadByLink(response.data)
          else
            this.$notify.add(response.meta.notice)
        })
        .catch(e => this.$notify.addError(e))
        .finally(() => this.closeGlobalLoad())
    },
    find() {
      this.asyncTemplateSelect()
    },
    showCredential(credential) {
      this.currentCredential = credential
      this.showModal = true
    }
  },
  mixins: [CheckedModels, ModelMapper, GlobalLoading],
  name: 'Credential',
  watch: {
    allAccounts: {
      deep: true,
      handler(value) {
        this.filterAccount = this.buildFilterAccount(value.data)
      }
    },
    orderBy(newValue, oldValue) {
      if (newValue === oldValue) return

      this.order = []
      this.addOrderBy(newValue, 'desc')
      this.find()
    }
  }
}
</script>

<style scoped>
.badge {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
}

.badge-success {
  background-color: #28a745;
  color: white;
}

.badge-secondary {
  background-color: #6c757d;
  color: white;
}
</style>
